export enum Widgets {
  ESTIMATED_COMMISSION = "estimated-commission",
  PROPERTY_DETAILS = "property-details",
  DEAL = "deal",
  FILES = "files",
  MARKETING = "marketing",
  POTENTIAL_BUYERS = "potential-buyers",
}
